import styled from "styled-components";
import TextGothic from "./utils/TextGothic";
import logo from "./../images/logomark.png";
import tagline from "./../images/tagline.png";
import { media } from "../utils/media";

const Header = () => {
  return (
    <Wrapper>
      <LogoHeader>
        <Link href="/">
          <LogoWrapper>
            <Logo src={logo} />
            <Tagline src={tagline} />
          </LogoWrapper>
        </Link>
      </LogoHeader>
      <SubHeader>
        <Link href="/ja/jp">
          <Title size="12px" weight="normal" lh={1}>
            国内線トップ
          </Title>
        </Link>
      </SubHeader>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1;
  background-color: white;
`;

const LogoHeader = styled.div`
  position: relative;

  ${media.sp`
    height: 45px;
  `}
  ${media.pc`
    height: 62px;
  `}
`;

const LogoWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  line-height: 0;

  ${media.sp`
    left: 12px;
  `}
  ${media.pc`
    left: 20px;
  `}
`;

const Logo = styled.img`
  ${media.sp`
    width: 70px;
    display: block;
  `}
  ${media.pc`
    width: 85px;
    display: inline-block;
  `}
`;

const Tagline = styled.img`
  ${media.sp`
    width: 70px;
    margin-top: 4px;
  `}
  ${media.pc`
    width: 140px;
    display: inline-block;
    margin-left: 10px;
  `}
`;

const SubHeader = styled.div`
  height: 30px;
  background-color: #f4f4f4;
  position: relative;
`;

const Link = styled.a``;

const Title = styled(TextGothic)`
  color: #00146e;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${media.sp`
    left: 12px;
  `}
  ${media.pc`
    left: 20px;
  `}
  &:hover {
    text-decoration: underline;
  }
`;

export default Header;
